module.exports = __webpack_public_path__ + "img/_ABS9785.6e137cba.jpg";